module.exports = __webpack_public_path__ + "img/code.9447f09e.png";